import {
  LayoutGrid,
  TypographyRhythm,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import LegalHeading from '@/app/components/LegalComponents/LegalHeading';
import LegalParagraph from '@/app/components/LegalComponents/LegalParagraph';

const SecurityPrivacyPolicy = (): JSX.Element => {
  const t = useTranslations();

  return (
    <LayoutGrid data-cy="oura-data-protection-and-trust-page">
      <TypographyRhythm className="col-main">
        <TypographyV3
          Element="h1"
          variant="h1"
          className="mb-4"
          data-cy="data-protection-title"
        >
          {t('sc_data_and_trust_title')}
        </TypographyV3>
        <TypographyV3 weight="bold" className="mb-8">
          {t('sc_updated_6_2024')}
        </TypographyV3>

        {/* OURAS COMMITMENT TO DATA SECURITY */}
        <LegalHeading
          level="I" // I
          tx="sc_commitment_heading"
        >
          <LegalParagraph tx="sc_commitment_p1" />
        </LegalHeading>

        {/* DATA FLOW AND PROTECTION */}
        <LegalHeading
          level="I" // II
          tx="sc_data_flow_heading"
        >
          <LegalParagraph tx="sc_data_flow_p1" />
          <LegalParagraph tx="sc_data_flow_p2" />
        </LegalHeading>

        {/* SECURITY MEASURES */}
        <LegalHeading
          level="I" // III
          tx="sc_security_measures_heading"
        >
          {/* SECURITY MEASURES > EDUCATION AND TRAINING  */}
          <LegalHeading
            level="A" // III.A
            tx="sc_security_measures_education_subheading"
            id="education-and-training-section"
          >
            <LegalParagraph tx="sc_security_measures_education_p1" />
          </LegalHeading>
          {/* SECURITY MEASURES > DEVICE MANAGEMENT  */}
          <LegalHeading
            level="A" // III.B
            tx="sc_security_measures_device_subheading"
            id="device-management-section"
          >
            <LegalParagraph tx="sc_security_measures_device_p1" />
          </LegalHeading>
          {/* SECURITY MEASURES > CLOUD SECURITY  */}
          <LegalHeading
            level="A" // III.C
            tx="sc_security_measures_cloud_subheading"
            id="device-management-section"
          >
            <LegalParagraph tx="sc_security_measures_cloud_p1" />
          </LegalHeading>
          {/* SECURITY MEASURES > VULNERABILITY MANAGEMENT  */}
          <LegalHeading
            level="A" // III.D
            tx="sc_security_measures_vulnerability_subheading"
            id="vulneraility-management-section"
          >
            <LegalParagraph tx="sc_security_measures_vulnerability_p1" />
          </LegalHeading>
        </LegalHeading>

        {/* COMPLIANCE AND REGULATIONS */}
        <LegalHeading
          level="I" // IIII
          tx="sc_compliance_and_regulations_heading"
        >
          {/* COMPLIANCE AND REGULATIONS > GDPR AND INTERNATIONAL TRANSFERS */}
          <LegalHeading
            level="A" // IIII.A
            tx="sc_compliance_and_regulations_gdpr_subheading"
            id="gdpr-and-international-transfers-section"
          >
            <LegalParagraph tx="sc_compliance_and_regulations_gdpr_p1" />
          </LegalHeading>
          {/* COMPLIANCE AND REGULATIONS > US STATE AND FEDERAL LAWS */}
          <LegalHeading
            level="A" // IIII.B
            tx="sc_compliance_and_regulations_us_and_fed_subheading"
            id="us-state-and-federal-laws-section"
          >
            <LegalParagraph tx="sc_compliance_and_regulations_us_and_fed_p1" />
          </LegalHeading>
        </LegalHeading>

        {/* VULNERABILITY DISCLOSURE */}
        <LegalHeading
          level="I" // IIIII
          tx="sc_vulnerability_disclosure_heading"
        >
          <LegalParagraph tx="sc_vulnerability_disclosure_p1" />
          <LegalParagraph tx="sc_vulnerability_disclosure_p2" />
        </LegalHeading>
      </TypographyRhythm>
    </LayoutGrid>
  );
};

export default SecurityPrivacyPolicy;
